import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=4df94edf&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"
import style0 from "./reviews.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,ReviewStars: require('/opt/build/repo/storefront/components/molecules/Review/ReviewStars.vue').default,BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,ReviewCard: require('/opt/build/repo/storefront/components/molecules/Review/ReviewCard.vue').default,PageNumbers: require('/opt/build/repo/storefront/components/legacy/global/page-numbers.vue').default})
